var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.1797 11.5119V7.43555C38.1797 7.08223 37.7736 6.88711 37.4994 7.10332L13.7268 25.6711C13.5248 25.8282 13.3613 26.0293 13.2489 26.2592C13.1365 26.489 13.078 26.7415 13.078 26.9974C13.078 27.2532 13.1365 27.5057 13.2489 27.7356C13.3613 27.9654 13.5248 28.1666 13.7268 28.3236L37.4994 46.8914C37.7789 47.1076 38.1797 46.9125 38.1797 46.5592V42.4828C38.1797 42.2244 38.0584 41.9766 37.858 41.8184L18.8736 27L37.858 12.1764C38.0584 12.0182 38.1797 11.7703 38.1797 11.5119V11.5119Z","fill":"#333333"}));
}

ArrowLeft.defaultProps = {"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
